/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemList_data = {
    readonly itemList: {
        readonly items: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly slug: string;
                    readonly " $fragmentRefs": FragmentRefs<"ListPageItem_listItem">;
                } | null;
            } | null> | null;
            readonly pageInfo: {
                readonly hasNextPage: boolean;
                readonly endCursor: string | null;
            };
        };
    };
    readonly " $refType": "ItemList_data";
};
export type ItemList_data$data = ItemList_data;
export type ItemList_data$key = {
    readonly " $data"?: ItemList_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemList_data">;
};



const node: ReaderFragment = (function(){
var v0 = [
  "itemList",
  "items"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "dischargeDateEnd"
    },
    {
      "kind": "RootArgument",
      "name": "dischargeDateStart"
    },
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "kind": "RootArgument",
      "name": "handoverDateEnd"
    },
    {
      "kind": "RootArgument",
      "name": "handoverDateStart"
    },
    {
      "kind": "RootArgument",
      "name": "includeArchived"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "perPage"
    },
    {
      "kind": "RootArgument",
      "name": "searchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "showFilters"
    },
    {
      "kind": "RootArgument",
      "name": "sortKey"
    },
    {
      "kind": "RootArgument",
      "name": "type"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtaEnd"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtaStart"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtdEnd"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtdStart"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ItemListPaginationQuery.graphql.ts')
    }
  },
  "name": "ItemList_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dischargeDateEnd",
          "variableName": "dischargeDateEnd"
        },
        {
          "kind": "Variable",
          "name": "dischargeDateStart",
          "variableName": "dischargeDateStart"
        },
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Variable",
          "name": "handoverDateEnd",
          "variableName": "handoverDateEnd"
        },
        {
          "kind": "Variable",
          "name": "handoverDateStart",
          "variableName": "handoverDateStart"
        },
        {
          "kind": "Variable",
          "name": "includeArchived",
          "variableName": "includeArchived"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "perPage",
          "variableName": "perPage"
        },
        {
          "kind": "Variable",
          "name": "searchQuery",
          "variableName": "searchQuery"
        },
        {
          "kind": "Variable",
          "name": "showFilters",
          "variableName": "showFilters"
        },
        {
          "kind": "Variable",
          "name": "sortKey",
          "variableName": "sortKey"
        },
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "type"
        },
        {
          "kind": "Variable",
          "name": "voyageEtaEnd",
          "variableName": "voyageEtaEnd"
        },
        {
          "kind": "Variable",
          "name": "voyageEtaStart",
          "variableName": "voyageEtaStart"
        },
        {
          "kind": "Variable",
          "name": "voyageEtdEnd",
          "variableName": "voyageEtdEnd"
        },
        {
          "kind": "Variable",
          "name": "voyageEtdStart",
          "variableName": "voyageEtdStart"
        }
      ],
      "concreteType": "ItemList",
      "kind": "LinkedField",
      "name": "itemList",
      "plural": false,
      "selections": [
        {
          "alias": "items",
          "args": null,
          "concreteType": "ListItemConnection",
          "kind": "LinkedField",
          "name": "__ItemList_itemList_items_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ListItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ListItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ListPageItem_listItem"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApplicationQuery",
  "abstractKey": null
};
})();
(node as any).hash = 'b82daad2cee0c9289c2761f2fd69a93e';
export default node;
